import React from "react";
import "./StaticHelpingToolkit.css";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";

const StaticHelpingToolkit = (props) => {
  const { showToolkit, setShowToolkit, toolkitData, structureToolkitData } =
    props;

  const { i18n } = useTranslation();
  const handleCloseModal = () => {
    setShowToolkit(false);
  };

  return (
    <Modal
      size="lg"
      show={showToolkit}
      centered
      aria-labelledby="example-modal-sizes-title-sm"
      className="ActivitiesCon"
    >
      <Modal.Header className="toolkitModalHeader">
        <Modal.Title id="contained-modal-title-vcenter  ">
          <h6 className="fw-bold m-0">
            {/* {toolkitData?.title} */}

            {
              structureToolkitData
                ? i18n.language === "en" //structure toolkit data
                  ? toolkitData?.titleEn
                  : toolkitData?.title
                : toolkitData?.title //menues toolkit data
            }
          </h6>
        </Modal.Title>
        <Button
          variant=""
          className="btn btn-danger ms-auto btn-sm"
          onClick={handleCloseModal}
        >
          <i className="fas fa-times"></i>
        </Button>
      </Modal.Header>
      <Modal.Body>
        {/* <div
          className="py-2"
          dangerouslySetInnerHTML={{
            __html: toolkitData?.description,
          }}
        /> */}

        {
          structureToolkitData ? (
            i18n.language === "en" ? ( //structure toolkit data
              <div
                className="py-2"
                dangerouslySetInnerHTML={{
                  __html: toolkitData?.descriptionEn,
                }}
              />
            ) : (
              <div
                className="py-2"
                dangerouslySetInnerHTML={{
                  __html: toolkitData?.description,
                }}
              />
            )
          ) : (
            <div
              className="py-2"
              dangerouslySetInnerHTML={{
                __html: toolkitData?.description,
              }}
            />
          ) //menues toolkit data
        }
      </Modal.Body>
    </Modal>
  );
};

export default StaticHelpingToolkit;
